// extracted by mini-css-extract-plugin
export default {"br":"Zp","w80":"aq","card":"bq","wrapper":"cq","fullView":"eq","profilePic":"fq","comment":"gq","animate":"hq","shimmer":"iq","square":"jq"};
    if(module.hot) {
      // 1738064238009
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  